var React = require('react');
import { Box, Container, Grid } from '@mui/material';
import MUIDataTable from 'mui-datatables';
import DeleteIcon from "@material-ui/icons/Delete";
import SearchIcon from "@material-ui/icons/Search";
import Button from "@mui/material/Button";
import SaveIcon from "@material-ui/icons/Save";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import IconButton from '@mui/material/IconButton';
import AccountBoxIcon from '@mui/icons-material/AccountBox';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import Typography from '@mui/material/Typography';
import Tooltip from '@mui/material/Tooltip';
import { MuiThemeProvider } from '@material-ui/core/styles';
import Toolbar from '@mui/material/Toolbar';
import CloseIcon from '@mui/icons-material/Close';
import { muiThemeDesign } from '../../mui-theme-design';
import moment from "moment";
import { makeStyles } from "@mui/styles";
import Checkbox from '@mui/material/Checkbox';
import DoNotDisturbIcon from '@mui/icons-material/DoNotDisturb';
import CheckIcon from '@mui/icons-material/Check';
import ReportGmailerrorredIcon from '@mui/icons-material/ReportGmailerrorred';
import { logger, handleExport, customBodyForExcelReport, checkAuthentication,muiLoaderOptions } from '../../utils';
const ExcelJS = require('exceljs');

const pageStyles = makeStyles(theme => ({
    root: {
        "& .MuiPaper-root": {
            overflowy: "hidden",
            color: '#ffffff'
        },
        "& .Mui-checked": {
            color: '#ffffff'
        },
        "& .MuiCheckBox-root": {
            color: '#ffffff'
        },
        "& .MuiSvgIcon-error": {
            color: '#c40018',
            fill: '#c40018',
        },

    },

}));

export default function HandelSOWBillingReport({ SOWID, name, display }) {
    const [refresh, setRefresh] = React.useState(false);
    const [Report, setReport] = React.useState([]);
    const [invoice, setInvoice] = React.useState([]);
    const [billTime, setBillTime] = React.useState([]);
    const [list, setList] = React.useState([])
    const [start, setStart] = React.useState();
    const [end, setEnd] = React.useState();
    const [Discount, setDiscount] = React.useState({})
    const [overTime, setsOverTime] = React.useState([])
    const [filename, setFilename] = React.useState(`SOWSummary_${name}.xlsx`)
    const [open, setOpen] = React.useState(false);
    const [isLoading, setIsLoading] = React.useState(true);
    const [bypass, setBypass] = React.useState(false);
    const timer = React.useRef(null); 

    const classes = pageStyles();

    const GetOverTime = async () => {
        const call = logger("GetOverTime", `sow: ${SOWID}`)
        await fetch(`/api/SOW/OverTime/${SOWID}`, {
            method: 'Get',
        })
            .then(res => res.json())
            .then(json => setsOverTime(json))
        return call
    };

    const getReport = async () => {
        
        logger(`/api/PO_SOW/${SOWID}`)
        const call = await fetch(`/api/PO_SOW/${SOWID}`, {
            method: 'Get',
        })
            .then(res => res.json())
            .then(json => {
                var output = []

                json.map((value, index) => {
                    var eachRow = value

                    eachRow.StartDate = moment.utc(eachRow.StartDate).format('MM/DD/YYYY')
                    eachRow.EndDate = moment.utc(eachRow.EndDate).format('MM/DD/YYYY')
                    output.push(eachRow)
                })
                setReport(output)
            })

        return call
    };

    const getInvoice = async () => {
        logger("getInvoice", `/api/InvoiceSOW/${SOWID}`)
        try {
            const call = await fetch(`/api/InvoiceSOW/${SOWID}`, {
                method: 'Get',
            })
                .then(res => res.json())
                .then(json => {
                    logger(`/api/InvoiceSOW/${SOWID}`, json);
                    var output = []
                    json.map((value, index) => {
                        output.push({
                            "InvoiceDate": value.InvoiceDate,
                            "PO": value.PO,
                            "InvoiceNumber": value.InvoiceNumber,
                            "StartDate": moment.utc(value.StartDate).format('MM/DD/YYYY'),
                            "EndDate": moment.utc(value.EndDate).format('MM/DD/YYYY'),
                            "Amount": value.Amount,
                            "ExpenseTotal": value.ExpenseTotal
                        })
                    })
                    setInvoice(output)
                })
        } catch (error) {
            console.error(`Error loading UserList`, error)
        }

        return true;
    };

    const calculateRate = (rate, flagType) => {
        if (overTime.length) {
            if (flagType === 'OT') {
                return (rate * overTime[0].OverTimeWeek).toFixed(2);
            } else if (flagType === 'WND') {
                return (rate * overTime[0].OverTimeWeekEnd).toFixed(2);
            } else if (flagType === 'HOL') {
                return (rate * overTime[0].OverTimeHoliday).toFixed(2);
            } else {
                return rate;
            }
        }
    }

    const getBillTime = async () => {
        logger("getBillTime", `/api/Reports/time_entry_SOW/${SOWID}`)
        const call = await fetch(`/api/Reports/time_entry_SOW/${SOWID}`, {
            method: 'Get',
        })
            .then(res => res.json())
            .then(json => {
                logger(`/api/Reports/time_entry_SOW/${SOWID}`, json);

                var output = []
                if (json.message == undefined) {
                    json.map((value, index) => {
                        var eachRow = value

                        var payRate = eachRow.Rate;
                        const byteArray = new Uint8Array(payRate.data);
                        const textDecoder = new TextDecoder();
                        const res = textDecoder.decode(byteArray);
                        const rate = parseFloat(res).toFixed(2);

                        eachRow.Rate = calculateRate(rate, eachRow.FlagType);

                        delete eachRow['ID']
                        delete eachRow['VerifyStatus']
                        delete eachRow['overTimeWarning']
                        delete eachRow['UserID']
                        delete eachRow['IsBillable']
                        delete eachRow['Lab_ID']
                        delete eachRow['ProjectID']
                        delete eachRow['timeEntryID']
                        if (!display) {
                            delete eachRow['Name']
                        }
                        eachRow.DayOf = moment.utc(eachRow.DayOf).format('MM/DD/YYYY')
                        eachRow.WeekOf = moment.utc(eachRow.WeekOf).format('MM/DD/YYYY')
                        output.push(eachRow)
                    })
                } else {
                    setBypass(true)
                }
                setBillTime(output)
            })

        return call
    };
    
    const handleClickOpen = () => {

        setRefresh(true)
        setOpen(true);
    };

    const generateReport = () => {
        logger('generateReport')
        logger("Report", Report)
        logger("invoice", invoice)
        logger("billTime", billTime)
        function populateWorksheet(worksheet, rows, headers) {
            if (headers && headers.length) {
                const headerRow = worksheet.addRow(headers);
                headerRow.font = { bold: true };
            } else {
                console.error("No headers found.");
            }

            if (rows && rows.length) {
                rows.forEach((row, rowIndex) => {
                    const rowData = Array.isArray(row) ? row : Object.values(row);
                    worksheet.addRow(rowData);

                    // Ensure columns auto-adjust width
                    worksheet.columns.forEach((col) => {
                        if (col && col.values) {
                            const maxColumnWidth = col.values.reduce((maxWidth, value) => {
                                if (value && value.toString().length > maxWidth) {
                                    return value.toString().length;
                                }
                                return maxWidth;
                            }, 10);
                            col.width = Math.min(maxColumnWidth + 2, 40); // Set a max width
                        }
                    });
                });
            } else {
                console.error("No rows data found.");
            }
        }
        // Custom buildHead and buildBody functions
       

        const rowsForTab1 = Report;
        const rowsForTab2 = invoice;
        const rowsForTab3 = billTime;

        const workbook = new ExcelJS.Workbook();
        const worksheet1 = workbook.addWorksheet('SOW');
        const worksheet2 = workbook.addWorksheet('Invoices');
        const worksheet3 = workbook.addWorksheet('TimeEntry');

        const headers1 = Object.keys(Report[0]);
     
        
        
        populateWorksheet(worksheet1, rowsForTab1, headers1);

        if (!bypass) {
            const headers2 = Object.keys(invoice[0]);
            populateWorksheet(worksheet2, rowsForTab2, headers2);
            const headers3 = Object.keys(billTime[0]);
            populateWorksheet(worksheet3, rowsForTab3, headers3);
        } else {
            populateWorksheet(worksheet2, [{ "message": "no invoice" }], ['alert']);
            populateWorksheet(worksheet3, [{ "message": "no time entry" }], ['alert'])
        }

        /*const customBuildHead = () => {
            var newColumns = Object.keys(Report[0]);
            return newColumns;
        }*/
        //const headers = customBuildHead();

        //const rows = customBuildBody();
        var add_date = true;
        const currentDate = moment.utc().format("yyyy-MM-DD");
        //handleExport({rows:rows, headers:headers, filename: 'LPCheck.xlsx'})
        workbook.xlsx.writeBuffer().then(buffer => {
            const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = add_date ? (currentDate + "_" + filename || currentDate + '_' + 'datatable.xlsx')
                : (filename || 'datatable.xlsx');
            a.click();
        }).catch(error => {
            console.error("Error generating Excel file: ", error);
        });
        return false;
    };

    async function processData() {
        try {
            const processOverTime = await GetOverTime()
            if (overTime.length > 0) {
                const processReport = await getReport()
                const processInvoice = await getInvoice()
                const processgetBillTime = await getBillTime()
            }
        } catch (error) {
            console.error(`Error processing`, error)
        }
        if (billTime.length > 0 || bypass) {
            setRefresh(false)
            generateReport()
        } else {
            timer.current = setTimeout(() => {
                setRefresh(true)
            }, 1000);

        }

    }

    React.useEffect(() => {
        if (refresh) {
            logger("refresh")
            
            processData()
            setRefresh(false);
        }

    })

    return (
        <div className={classes.root}>
            <Button autoFocus onClick={handleClickOpen}>
                Download
            </Button>
        </div>
    );
}

 